import { user, request, track, messenger } from 'lib';

import find from 'lodash/find';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import uniqBy from 'lodash/uniqBy';

import { UiToast } from 'components';
import { globalStore } from 'stores';
import filter from 'lodash/filter';
import { getStore } from './store/gift';
import { room, socket } from '../../lib';

import bag from './bag';
// import marquee from '../marquee/marquee';

import sendTip from './send-tip';
import { pushAwardItems } from './luck-award';

let giftList = [];
let extraGiftList = [];
let categoryList = [];
let categories = [];

// roomType  -1:个播; 1:舞台房; 2:神豪厅; 3:多人pk房; 6: 多人派对房;
const init = async (roomType, cb) => {
  // const isParty = roomType === 6;
  const giftApi = 'api/v3/cats/gifts';

  const res = await request.cryolite.get(giftApi, {
    // roomType,
    // request_source: 'PC',
    // hd1的时候只展示互动类的打棒球，hd2的展示互动下面的超级火箭和打棒球
    // 除此之外不展示互动类礼物
    // interact: 'hd2',
    room_id: room.getRoomId(),
    magic_gift: true,
    live_stream_type: 2, // 手机版 显示所有礼物，前端自己做不同类型的
  });

  giftList = res.data.gifts.concat(extraGiftList);
  categoryList = res.data.cats;

  // 对 多人派对房 仅展示 id=55,22 分类
  // if (isParty) {
  //   categoryList = categoryList.filter((item) => [55, 22].includes(item.id));
  // }

  updateGiftData();

  messenger.setActions({
    refreshBag: () => {
      user.loadUserInfo();
      bag.init();
    },
  });

  await bag.init();
  getMultiLuckyInfo();

  initSocket();

  cb && cb();
};

const initSocket = () => {
  // 通知幸运礼物进度条变化
  socket.socketEvent.on('multi_lucky_gift.crit_progress', (msg) => {
    getStore().updateMultiLuckyGiftItem(msg.data);
  });

  socket.socketEvent.on('multi_lucky_gift.reward', (msg = {}) => {
    const { giftId, reward = [] } = msg.data || {};
    let allMultiple = 0;
    let allPrize = 0;
    reward.forEach((item) => {
      const { multiple = 0, prize = 0 } = item;
      allMultiple += multiple;
      allPrize += prize;
    });
    // const giftInfo = gift.getGift(giftId) || {}
    const allAward = [
      {
        multiple: allMultiple,
        prize: allPrize,
        // gift_pic: giftInfo.pic_url || '',
        // gift_name: giftInfo.name || ''
      },
    ];
    pushAwardItems(allAward);
  });
};

const updateGiftData = () => {
  const categoriesObj = {};

  forEach(categoryList, (cat) => {
    categoriesObj[cat.name] = categoriesObj[cat.name] || {};
    const catObj = categoriesObj[cat.name];
    catObj.gifts = catObj.gifts || [];
    catObj.name = cat.name;
    catObj.order = cat.order;
    catObj.id = catObj.id ? `${catObj.id}_${cat.id}` : `${cat.id}`;
    const gs = (cat.cat_gifts || []).map((gift) => {
      return giftList.find((i) => {
        return i.id === gift.gift_id && i.sale;
      });
    });

    catObj.gifts = catObj.gifts.concat(gs);
  });

  categories = map(categoriesObj, (item) => {
    return {
      ...item,
      gifts: uniqBy(
        filter(item.gifts, (i) => {
          return !!i;
        }),
        (a) => {
          return a.id;
        },
      )
        .filter((a) => {
          if (a.sale) {
            return !(a.room_id && a.room_id !== room.getRoomId());
          }
          return false;
        })
        .sort((a, b) => {
          if (a.coin_price === b.coin_price) {
            return b.order - a.order;
          }
          return a.coin_price - b.coin_price;
        }),
    };
  });

  getStore().update(categories, giftList);
};

const getMultiLuckyInfo = () => {
  request.cryolite.get('api/v5/multi-lucky-gift/crit-info').then((res) => {
    getStore().updateMultiLuckyGifts(res.data.prize);
  });
};

const updateGiftList = (list) => {
  giftList = list;
};

const getGiftList = () => {
  return giftList;
};

const getGift = (giftId) => {
  return find(giftList, { id: giftId });
};

const sendGift = async (options) => {
  const {
    isBag,
    giftId,
    count,
    roomId,
    userId,
    isMarquee = true,
    callback,
  } = options;
  // ?count={count}&user_id={user_id}&marquee={marquee}
  // ?count={count}&user_id={user_id}&marquee={marquee}
  if (!/^[0-9]*[1-9][0-9]*$/.test(count)) {
    return UiToast.warn('礼物数量必须为整数哦~');
  }

  if (!globalStore.isLogin) {
    return user.popupLogin();
  }
  // if (globalStore.userId === userId) {
  //   return UiToast.warn('不能给自己送礼哦~');
  // }

  const url = isBag
    ? `room/bag_gift/{access_token}/${roomId}/${giftId}`
    : `room/send_gift/{access_token}/${roomId}/${giftId}`;
  // if (giftId === 283) {
  //   url = 'fortune/send_fortune'
  // }

  // 走特殊送礼流程
  // packet  红包礼物
  // bell  铃铛礼物

  return request.api
    .get(url, {
      token: true,
      count,
      gift_id: giftId,
      room_id: roomId,
      user_id: userId,
      marquee: isMarquee ? 'yes' : 'no',
      policy_flag: sendTip.getPolicyFlag(roomId === userId),
      policy_flag_type: roomId === userId ? 1 : 0, // 提示的标识 区分主播、用户，主播：1，用户：0
    })
    .then((res) => {
      track.send({
        event: 'trace_send_gift',
        event_type: 'trace_send_gift_success',
        content: res,
        user_id: userId,
        room_id: roomId,
        gift_id: giftId,
        gift_count: count,
        platform: 'PC',
      });

      callback && callback();
    })
    .catch((res) => {
      track.send({
        event: 'trace_send_gift',
        event_type: 'trace_send_gift_failed',
        content: res,
        user_id: userId,
        room_id: roomId,
        gift_id: giftId,
        gift_count: count,
        platform: 'PC',
      });
      if (
        sendTip.handleTip(res, () => {
          sendGift(options);
        })
      ) {
        return;
      }
      UiToast.fail(res.msg);
      return Promise.reject(res);
    });
};

const sendMultiRoomGift = (options) => {
  const {
    isBag,
    star_list,
    marquee,
    gift_id,
    count,
    stage_room_id,
    policy_flag = sendTip.getPolicyFlag(true),
    policy_flag_type = 1,
  } = options;

  const url = isBag
    ? '/multireceiver/bag_gift.json'
    : '/multireceiver/send_gift.json';

  let data = {
    token: true,
    star_list,
    marquee: marquee ? 'yes' : 'no',
    gift_id,
    count,
    stage_room_id,
    policy_flag,
    policy_flag_type,
  };

  // 兼容处理不同类型房间送礼参数不一样
  data = event.onBeforeSend(data);

  return request.api.get(url, data).catch((res) => {
    track.send({
      event: 'trace_send_gift',
      event_type: 'trace_send_gift_failed',
      content: res,
      room_id: stage_room_id,
      gift_id: gift_id,
      gift_count: count,
      platform: 'PC',
    });
    if (
      sendTip.handleTip(res, () => {
        sendMultiRoomGift(options);
      })
    ) {
      return;
    }
    UiToast.fail(res.msg);
    return Promise.reject(res);
  });
};

const event = {
  onBeforeSend: (data) => {
    return data;
  },
  /**
   * 选中礼物
   * @param giftId 礼物id
   * @returns {boolean} 返回false 为不选中
   */
  onBeforeSelect: (giftId) => {
    return true;
  },
};

const isAnchorRoom = false;

const addExtraGift = (gifts) => {
  extraGiftList = extraGiftList.concat(gifts);
  giftList = extraGiftList.concat(giftList);
  updateGiftData();
};

export default {
  init,
  getGift,
  addExtraGift,
  getGiftList,
  updateGiftList,
  sendMultiRoomGift,
  sendGift,
  event,
  isAnchorRoom,
  getMultiLuckyInfo,
};
